module.exports = __webpack_public_path__ + "static/media/training_instructor_somatic_exercise.d69e3496.webp";